import React from 'react'
import css from './Home.module.css'
import logo from '../assets/v.png'
import me from '../assets/me-dark.jpg'
import { motion } from "framer-motion";
import { fadeIn, slideIn, staggerContainer } from "../utils/motion";


const Home = () => {
  return (
<>
{/* <div className={css.homebg} id='home'> */}
<a className="position_atag"  id='home'></a>

     <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.25 }}
        // className={`innerWidth ${css.container}`}
        className={css.homebg}
      >
    {/* <div className={css.leftdiv}> */}
          <motion.div className={css.leftdiv} variants={fadeIn("right", "tween", 0.2, 1)}>
<p>Hy! I Am</p>
{/* <p>Vinoth Kumar R</p> */}
<p>Vno</p>
{/* <img src={logo}/> */}
<p> ( Full Stack Developer )</p>
<a href='#experience'>
<b>//</b> Internship - CodeParva Technologies Pvt. Ltd - Bangalore.
  
  </a>
<p>
  {/* I have completed my MERN stack development course, and I am eager to apply my skills in web designing and development, producing quality work to create engaging web applications. Currently, I am looking for a job. */}
     {/* Frontend Developer with high level of experience in */}
     I have completed my MERN stack development course, and I am eager to apply my skills in web designing and development, producing quality work to create engaging web applications. Currently, I am looking for a better opportunity to build my career.
    </p>
    <a className={css.resume_btn} href='https://drive.google.com/file/d/1ftbdVavJFA032wMCULiwVXcetdOmGjbc/view' target='_blank'>Resume</a>
    </motion.div>

    {/* </div> */}
    {/* <div className={css.rightdiv}> */}
    <motion.div className={css.rightdiv} variants={fadeIn("left", "tween", 0.2, 1)}>

        <div>
            <img src={me}/>
        </div>
        </motion.div>
    {/* </div> */}
    </motion.div>
{/* </div> */}
</> 
 )
}

export default Home